export const ZhLocale = {
    page: {
        txtTitle: 'SHIRITORI | 用有趣的 しらとり 在线游戏轻松学习日语词汇',
    },
    common: {
        txtLogoAlt: 'Shiritori 列车',
    },
    header: {
        txtLeave: '退出游戏',
    },
    dialog: {
        leave: {
            txtTitle: '要退出这局游戏吗？',
            btnStay: '留在游戏中',
            btnLeave: '退出并认输',
        },
    },
    home: {
        btnNewGame: '新游戏',
        btnMainMenu: '主菜单',
        btnJoinGame: '加入',
        btnReturnToGame: '返回游戏',
    },
    create: {
        headingNamePrompt: '我们该怎么称呼你？',
        placeholderName: '你的名字',
        btnOk: '确定',
    },
    join: {
        placeholderName: '你的名字',
        placeholderGameId: '游戏ID',
        btnJoinGame: '加入',
    },
    configure: {
        header: '游戏设置',
        labelExpectedPlayers: '玩家人数',
        labelBoardSize: '棋盘大小',
        labelWordList: '词汇列表',
        labelAllowHints: '允许提示',
        labelTurnTimer: '回合计时',
        optionNoTimer: '无计时',
        optionTimer: '计时器',
        unitSeconds: '秒',
        btnStartGame: '开始',
        toastCreateError: '错误：无法创建此游戏',
        toastTryAgain: '错误：请稍后重试。',
    },
    game: {
        lobby: {
            btnReady: '准备好了',
            txtShareInvite: '把这个代码分享给你的朋友！',
            txtPlayer: '玩家',
            txtTeam: '队伍',
        },
        message: {
            noSuchGame: '该游戏不存在',
            txtLoading: '加载中...',
            txtCannotJoin: '无法加入游戏',
        },
        gameplay: {
            board: {
                timeoutTitle: '时间',
                timeoutSubtitle: '到',
            },
            wordSearch: {
                multipleMatches: '找到多个匹配！',
                yourTurn: '轮到你了',
                placeholder: '我们该出什么词？',
                playAction: '出词',
                timerSeconds: '{{seconds}}秒',
                toastNoSuchWord: '没有这个词！',
                toastCantPlay: '这个词不能出！',
                toastPlayed: '已出“{{word}}”',
                toastPlayFailed: '哎呀，这个词出不了！',
                validation: {
                    syllableMismatch: '起始音节不匹配',
                    missingLastWord: '上一回合没有单词',
                    wordNotInList: '该词不在所选列表中',
                }
            },
            spectate: {
                waitingOn: '等待 {{player}}',
                timeLeft: '剩余时间：{{seconds}}秒',
            },
            endGame: {
                header: '游戏结束',
                viewResults: '查看结果',
                statsTotalTime: '总游戏时长',
                statsSquaresFilled: '已填格数',
                statsLongestWord: '最长单词',
                share: '分享',
                sharing: '分享中...',
                ariaCloseLabel: '关闭游戏结束弹窗',
            }
        },
    },
    footer: {
        linkHowToPlay: '玩法说明',
        linkPrivacyPolicy: '隐私政策',
        txtAllRightsReserved: '版权所有。',
    },
    howToPlay: {
        title: '如何玩 Shiritori しりとり (shiritori)',
        btnPlayNow: '立即开始！',
        btnReturnToGame: '返回游戏：',
        description1: 'b|Shiritori| 是我们对日语接龙游戏 しりとり 的在线多人改编版。你可以和朋友一起或单人练习词汇，同时拼出图片棋盘。',
        description2: '创建或加入一局游戏，选择棋盘大小、图片集和词汇列表，然后在有人失误前，用有效单词尽快填满网格。',
        gameSetup: {
            title: '创建或加入游戏',
            p1: '你可以单人开始，也可以通过可分享链接或游戏代码邀请最多 9 位朋友（共 10 人）。',
            p2: '选择你想要的选项：棋盘大小（3x3、5x5、7x7）、背景图案/颜色、图片集以及要学习的词汇列表。',
            p3: '朋友打开链接，选择昵称后会出现在大厅；当达到预期人数时游戏开始。',
            p4: '迟到的玩家也可以用仅观看模式旁观正在进行的对局。',
        },
        objective: {
            title: '目标',
            p1: '让每个新词都以前一个词的最后一个音节开头，填满棋盘，并且不要让单词以 ん 结尾。',
        },
        wordRules: {
            title: '有效单词',
            p1: '可输入假名或罗马字；在校验前，罗马字会在客户端转换为平假名。',
            p2: '单词必须存在于所选列表中（常用 100/1000、食物、运动等），并会在出词后显示含义。',
            p3: '已使用过的单词会被禁用。如果允许同音词，你可以选择带有正确图片且尚未使用的变体。',
            li1: '以前一回合要求的音节开头',
            li2: '不以 ん (n) 结尾',
            li3: '包含在所选词汇列表中',
            li4: '本局中尚未使用过',
            li5: '当规则启用时，使用允许的同音词/图片组合',
            p4: '每次有效出词都会按顺序把对应图片放入棋盘，从左到右、从上到下填充。e|示例:_そば_→_バス|',
        },
        turnFlow: {
            title: '回合与计时',
            p1: '回合按玩家列表轮转；当轮到你时，从你看到自己回合开始最多有 10 秒。',
            p2: 'Shiritori 会等到下一位玩家处于活跃状态（浏览器窗口聚焦）才开始倒计时，防止通过重启或刷新跳过计时。',
            p3: '输入你的单词，查看实时校验，并在截止前提交；无效或超时提交会立即结束对局。',
        },
        boardFlow: {
            title: '棋盘、流程与结束',
            p1: '棋盘会显示每个已出单词及其图片、玩家名和回合编号，并用箭头标示网格中的顺序。',
            p2: '轮到别人时，你仍可看到下一词所需起始音节和倒计时。',
            p3: '若所有格子都被有效单词填满，游戏将成功结束，并显示可分享的完整棋盘。',
            p4: '如果在计时结束前没人提交有效词，游戏会结束并总结谁超时或提交了无效单词。',
        },
        summary: {
            title: '总结',
            p1: 'Shiritori 让しりとり节奏更快、画面更直观。短回合、清晰规则和图片记忆法帮助大家持续接龙。',
            p2: '分享链接，填满棋盘，看看你的词链能坚持多久。',
        }
    },
    bugsAndFeatures: {
        title: '问题反馈与新功能',
        p1: '我们把经典的 k|しりとり.| 做成了另一种玩法。作为热爱游戏的团队，我们一直在寻找让游戏更好玩的方法。',
        cta: {
            l1: '其实，如果你愿意通过',
            a: '把我们的游戏分享给朋友',
            l2: '并发布到社交媒体来支持我们，我们会非常感谢！'
        },
        p2: '如果你遇到任何错误，或对新功能有建议，请告诉我们！',
        bugs: {
            title: 'Bug 反馈',
            p1: '请直接在我们的公开 a|https://github.com/indexinteractive/|GitHub_仓库| 反馈任何异常行为、错误或 bug。请尽量提供详细信息，包括复现步骤。'
        },
        features: {
            title: '新功能',
            p1: '如果你对新功能、改进或玩法有想法，欢迎在我们的 a|https://github.com/indexinteractive/|GitHub_Discussions| 页面发起新讨论。'
        }
    },
    share: {
        title: 'Shiritori | 用有趣的 しらとり 在线游戏轻松学习日语词汇 - SHIRITORI',
        text: '和朋友或随机玩家在线玩 Shiritori。无需注册！',
    }
};
